import { StackProps, useDisclosure, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FilterButton } from "../../../components/button/FilterButton";
import { TitlePageDashboard } from "../../../components/button/TitlePageDashboard";
import { OrderStatusCard } from "../../../components/card/OrderStatusCard";
import { ConfirmationPermissionModal } from "../../../components/modal/ConfirmationPermissionModal";
import { CardSkeleton } from "../../../components/skeleton/CardSkeleton";
import { OrderStatusInterface } from "../../../constants/OrderStatus";
import { SelectOption } from "../../../constants/SelectOption";
import useCustomToast from "../../../lib/useCustomToast";
import { useBgBaseColor } from "../../../themes/colors";
import {
  getAxiosInstance,
  getModalPermission,
} from "../../../utils/helperFunction";

interface Props extends StackProps {
  pageType: number; // 1=buyer, 2=reseller, 3=supplier
}

export const OrderStatus = ({ pageType, ...rest }: Props) => {
  const [selectedFilter, setSelectedFilter] = useState<
    SelectOption | undefined
  >({ id: "all", name: "all" });
  const [loaded, setLoaded] = useState<boolean>(false);
  const [data, setData] = useState<OrderStatusInterface[] | undefined>(
    undefined
  );
  const [unpaidPurchases, setUnpaidPurchases] = useState<
    OrderStatusInterface[] | undefined
  >(undefined);
  const bgBase = useBgBaseColor();
  const toast = useCustomToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (pageType === 1) {
      if (getModalPermission()) {
        onOpen();
      }
    }
  }, [pageType]);

  useEffect(() => {
    const axiosInstance = getAxiosInstance(pageType);

    const request = {
      status: selectedFilter?.id.toString(),
    };

    let userType: string = "buyer";

    if (pageType === 2) {
      userType = "reseller";
    } else if (pageType === 3) {
      userType = "supplier";
    }

    axiosInstance
      .post(`/v1/${userType}/purchase`, request)
      .then((res) => {
        setData(res.data.data.purchase);

        if (res.data.data.payment) {
          const nonExpiredData = res.data.data.payment.filter(
            (product: any) => product.expired === 0
          );

          if (nonExpiredData.length > 0) {
            setUnpaidPurchases(nonExpiredData);
          }
        }
      })
      .catch((err) => {
        toast();
      })
      .finally(() => {
        setLoaded(true);
      });
  }, [selectedFilter, pageType]);

  return (
    <>
      <VStack
        className="order-status-page"
        w={"100%"}
        p={4}
        bg={bgBase}
        align={"stretch"}
        {...rest}
      >
        <TitlePageDashboard title="Status Pesanan" />

        <FilterButton
          w={"fit-content"}
          onConfirm={(select) => {
            setSelectedFilter(select);
          }}
        />

        {!loaded ? (
          <CardSkeleton row={1} column={10} height={120} mt={4} />
        ) : (
          <VStack w={"100%"} gap={4} mt={4}>
            {pageType === 1 && selectedFilter?.id === "all" && (
              <VStack w={"100%"} gap={4} align={"stretch"}>
                {unpaidPurchases &&
                  unpaidPurchases.length > 0 &&
                  unpaidPurchases.map((item) => (
                    <OrderStatusCard
                      unpaid={true}
                      key={item.id}
                      item={item}
                      pageType={pageType}
                    />
                  ))}
              </VStack>
            )}

            {data &&
              data.length > 0 &&
              data.map((item) => (
                <OrderStatusCard
                  key={item.id}
                  item={item}
                  pageType={pageType}
                />
              ))}
          </VStack>
        )}
      </VStack>

      <ConfirmationPermissionModal
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        children={undefined}
      />
    </>
  );
};
